"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireWildcard(require("react"));

var _Dialog = _interopRequireDefault(require("../Dialog"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var SuccessDialog = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SuccessDialog, _Component);

  var _super = (0, _createSuper2["default"])(SuccessDialog);

  function SuccessDialog() {
    (0, _classCallCheck2["default"])(this, SuccessDialog);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SuccessDialog, [{
    key: "_handleClose",
    value: function _handleClose() {
      var _this$props = this.props,
          name = _this$props.name,
          onClose = _this$props.onClose,
          closeDialog = _this$props.closeDialog;
      onClose && onClose();
      closeDialog(name);
    }
  }, {
    key: "_handleConfirm",
    value: function _handleConfirm() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          onConfirm = _this$props2.onConfirm,
          closeDialog = _this$props2.closeDialog;
      onConfirm && onConfirm();
      closeDialog(name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _data = _this$props3._data,
          title = _this$props3.title,
          name = _this$props3.name,
          message = _this$props3.message,
          caption = _this$props3.caption,
          mode = _this$props3.mode,
          inProcess = _this$props3.inProcess;
      return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        _data: _data,
        name: name
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['confirm']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['header']
      }, title && /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['title'],
        "data-locator": "".concat(_data, ".title")
      }, title), /*#__PURE__*/_react["default"].createElement("span", {
        className: _defaultModule["default"]['message'],
        "data-locator": "".concat(_data, ".message")
      }, message)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['footer']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
        _data: _data + '.apply',
        mode: mode,
        disabled: inProcess,
        onClick: this._handleConfirm.bind(this)
      }, caption), /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
        _data: _data + '.cancel',
        form: "outline",
        disabled: inProcess,
        onClick: this._handleClose.bind(this)
      }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"))));
    }
  }]);
  return SuccessDialog;
}(_react.Component);

SuccessDialog.defaultProps = {
  _data: 'confirm',
  inProcess: false,
  title: null,
  name: 'confirm',
  mode: 'success',
  message: 'Подтвердить действие?',
  caption: 'Подтвердить'
};
var _default = SuccessDialog;
exports["default"] = _default;